/**
 * Implicitní šířka sloupčků gridu.
 */
export const COL_DEFAULT_WIDTH = 140;
/**
 * Id a kód sloupce, který obsahuje číslo JP.
 */
export const COL_REFERENCE_MARK = '_referenceMark';
